// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__33v03","title":"AfterBackImages_title__hAHP_","images":"AfterBackImages_images__10HJH"};